<h1 matDialogTitle>TFG Rewards Lines Breakdown</h1>

<mat-dialog-content>
  <div style="width: 100%">
    <kendo-grid height="570" [data]="gridData" [resizable]="true">

      <ng-template kendoGridToolbarTemplate>
        <button type="button" kendoGridExcelCommand>
          Export to Excel
        </button>
      </ng-template>

      <kendo-grid-column
        [width]="100"
        field="line_number"
        title="line_number">
      </kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="unit_sequence"
        title="unit_sequence"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="has_normal_discount"
        title="has_normal_discount"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="alternate_key_1"
        title="alternate_key_1"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="200"
        field="buy_cat_1"
        title="buy_cat_1"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="200"
        field="buy_cat_2"
        title="buy_cat_2"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="200"
        field="buy_cat_3"
        title="buy_cat_3"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="part_category"
        title="part_category"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="200"
        field="department"
        title="department"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="300"
        field="sub_department"
        title="sub_department"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="400"
        field="product_code"
        title="product_code"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="400"
        field="buyers_class"
        title="buyers_class"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="stock_code"
        title="stock_code"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="order_qty"
        title="order_qty"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="unit_rsp_including_vat"
        title="unit_rsp_including_vat"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_id"
        title="product_campaign_id"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_sequence"
        title="product_campaign_sequence"
      ></kendo-grid-column>

      <kendo-grid-column
        field="product_campaign_used_for_purchase"
        title="product_campaign_used_for_purchase"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_used_for_redeem"
        title="product_campaign_used_for_redeem"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_redeem_value"
        title="product_campaign_redeem_value"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_redeem_value_type"
        title="product_campaign_redeem_value_type"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_total_rsp_including_vat"
        title="product_campaign_total_rsp_including_vat"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_unit_ratio"
        title="product_campaign_unit_ratio"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_unit_discount_amount"
        title="product_campaign_unit_discount_amount"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_sequence_total_discount_amount"
        title="product_campaign_sequence_total_discount_amount"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_sequence_total_rsp_including_vat"
        title="product_campaign_sequence_total_rsp_including_vat"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_sequence_unit_ratio"
        title="product_campaign_sequence_unit_ratio"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_sequence_unit_discount_amount"
        title="product_campaign_sequence_unit_discount_amount"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="product_campaign_sequence_rounding_fix"
        title="product_campaign_sequence_rounding_fix"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="global_campaign_id"
        title="global_campaign_id"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="global_campaign_sequence"
        title="global_campaign_sequence"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="global_campaign_redeem_value"
        title="global_campaign_redeem_value"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="global_campaign_redeem_value_type"
        title="global_campaign_redeem_value_type"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="global_campaign_total_rsp_including_vat"
        title="global_campaign_total_rsp_including_vat"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="global_campaign_total_discount"
        title="global_campaign_total_discount"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="global_campaign_unit_ratio"
        title="global_campaign_unit_ratio"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="global_campaign_unit_discount_amount"
        title="global_campaign_unit_discount_amount"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="global_campaign_rounding_fix"
        title="global_campaign_rounding_fix"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="100"
        field="rewards_total_unit_discount_amount"
        title="rewards_total_unit_discount_amount"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="300"
        field="creation_user"
        title="creation_user"
      ></kendo-grid-column>

      <kendo-grid-column
        [width]="300"
        field="creation_date"
        title="creation_date"
      ></kendo-grid-column>
      <kendo-grid-excel [fileName]="filename"></kendo-grid-excel>

    </kendo-grid>
  </div>
</mat-dialog-content>

<mat-dialog-actions [attr.align]="'start'">
  <button mat-button matDialogClose>Close</button>
</mat-dialog-actions>
